"use strict";
var date_pair_component_1 = require("./date-pair.component");
exports.DatePairComponent = date_pair_component_1.DatePairComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/date-pair/index.js